
import type { PropType } from 'vue'
import type { PaymentRequest } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

import { defineComponent, reactive, watch } from 'vue'

import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

// > services/payment-requests
import paymentRequestsAPI from '@/modern/modules/m-accounting-module/services/payment-requests.service'

//
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
        paymentRequest: {
            type: Object as PropType<PaymentRequest | null>,
            default: null
        }
    },
    emits: ['update:modelValue', 'close', 'payed'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            isLoading: false,
            file: null as File | null
        })

        const state_form$ = useVuelidate({
            file: { required }
        }, state)

        const onClose = () => {
            if (props.disabled) return
            emit('close')
        }

        const onUpdateModelValue = (newValue: boolean) => {
            if (props.disabled) return
            emit('update:modelValue', newValue)
        }

        const onSubmit = async () => {
            if (!props.paymentRequest) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.isLoading = true

                const form_data = new FormData()
                form_data.append('file', state.file as File)

                await paymentRequestsAPI.payPaymentRequest(props.paymentRequest.id, form_data)

                notifications.notify({ type: 'success', title: 'Заказ оплачен' })
                emit('payed')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'Не удалось провести оплату' })
            } finally {
                state.isLoading = false
            }
        }

        watch(
            () => props.modelValue,
            (newValue) => {
                if (newValue === false) {
                    state.file = null
                    state_form$.value.$reset()
                }
            }
        )

        return {
            state,
            state_form$,
            onClose,
            onSubmit,
            onUpdateModelValue,
            formatPriceToTenge,
        }
    }
})
